netbank = {}
netbank.buildHtmlFromJson = function ( json, containerId ) {
  var i,
    paragraph,
    span,
    br,
    a;
  var types = json.text;
  paragraph = document.createElement( 'p' );
  document.getElementById( containerId ).innerHTML = '';
  document.getElementById( containerId ).appendChild( paragraph );
  for ( i = 0; i < types.length; i++ ) {
    switch ( types[ i ].type ) {
      case 'text':
        paragraph.innerHTML = paragraph.innerHTML + types[ i ].value;
        break;
      case 'link':
        a = document.createElement( 'a' );
        a.setAttribute( 'href', types[ i ].url );
        if ( types[ i ].target === 'new' ) {
          a.setAttribute( 'target', '_blank' );
        }
        a.innerHTML = types[ i ].value;
        paragraph.appendChild( a );
        break;
      case 'break':
        if ( i > 0 && types[ i - 1 ].type === 'break' ) {
        }
        else {
          document.getElementById( containerId ).appendChild( paragraph );
          paragraph = document.createElement( 'p' );
        }
        break;
      default:
    }
  }
}
netbank.getStatus = function() {
  var jqXHRnetbankDrift = jQuery.ajax( {
    dataType: 'jsonp',
    url: 'https://netbank.vestjyskbank.dk/signon/drift/info?pragma=BECJson/1.0&language=DA'
  } );
  jqXHRnetbankDrift.done( function ( data ) {
    if ( data.text !== undefined && data.text.length > 0 ) {
      var containerId = 'vb-netbank-login-tab-status';
      netbank.buildHtmlFromJson( data, containerId );
      // jQuery( '.js-vb-netbank-login-tab-status-show-link' ).removeClass( 'hidden' ).find( 'a' ).on( 'click', function ( event ) {
      //   event.preventDefault();
      //   var tabs = document.querySelectorAll('.tabs ul li');
      //   var lastTab = tabs[tabs.length - 1];
      //   var tabLink = lastTab.querySelector('a');
      //   tabLink.click();
      // } );
    }
  } );
  jqXHRnetbankDrift.fail( function ( req, errorType, e ) {
    console.log( 'Netbank drift info service fejl:', req, errorType, e );
  } );
}
document.addEventListener('DOMContentLoaded', function() {
  netbank.getStatus();
});